import { Link } from "react-router-dom";
import { LOGO } from "@/data";
import { useLang } from "@/context/LanguageContext";

export const Footer = () => {
  const { t } = useLang();
  const f = t.footer;
  return (
    <footer className="bg-[#0D2A27] border-t border-[#F7F6F2]/10 py-14" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <div className="flex items-center gap-3">
            <img src={LOGO} alt="U-Heal" className="h-12 w-auto object-contain bg-[#F7F6F2] rounded-md p-1" />
            <p className="font-serif text-2xl text-[#F7F6F2]">U-Heal</p>
          </div>
          <div className="flex flex-wrap gap-x-8 gap-y-3 text-sm text-[#F7F6F2]/70">
            {f.links.map((l) => (
              <Link key={l.href} to={l.href} className="transition-colors hover:text-[#C4A484]">{l.label}</Link>
            ))}
          </div>
        </div>
        <div className="mt-10 pt-8 border-t border-[#F7F6F2]/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-[#F7F6F2]/50">
          <p>© {new Date().getFullYear()} U-Heal. {f.copyright}</p>
          <p>{f.disclaimer}</p>
        </div>
      </div>
    </footer>
  );
};
